import styled from '@emotion/styled';

import { commentMarkSelector } from './anchor/grammar';

const commentMark = commentMarkSelector();

export const SectionContent = styled.div`
    box-sizing: border-box;
    display: block;
    text-align: left;
    width: 100%;
    white-space: break-spaces;
    word-wrap: break-word;
    overflow-wrap: break-word;
    color: var(--color-text-primary);
    & > p {
        margin: 0;
    }
    & > ul {
        margin: 0;
    }

    & ul, & ol, & li {
        white-space: normal;
    }

    ${commentMark} {
        background-color: var(--color-comment-highlight-surface);
        color: inherit;
        border-radius: ${({ theme }) => theme.borderRadius.s};
        padding: 1px 0;
        cursor: pointer;
        transition: background-color 200ms ease;
        -webkit-box-decoration-break: clone;
        box-decoration-break: clone;
    }
    ${commentMark} ${commentMark} {
        background-color: var(--color-comment-highlight-nested-surface);
    }
    ${commentMark}:hover,
    ${commentMark}.is-active,
    ${commentMark}.is-pending {
        background-color: var(--color-comment-highlight-active-surface);
    }
    ${commentMark}:hover ${commentMark},
    ${commentMark}.is-active ${commentMark},
    ${commentMark}.is-pending ${commentMark},
    ${commentMark} ${commentMark}:hover,
    ${commentMark} ${commentMark}.is-active,
    ${commentMark} ${commentMark}.is-pending {
        background-color: var(--color-comment-highlight-active-surface);
    }
`;
